import { LangEum } from '@/constant'

const zhTWLang = {
  fullReduct(money: number, currencyCode: string) {
    return `滿${currencyCode || ''}${Number(money / 100) || ''}可用`
  },
  overdueMsg: '很抱歉，您的禮品包已過期',
  sorryTopMsg: '很抱歉，您是POIZON的老朋友了',
  sorryBottomMsg: '禮品包是新用戶專享福利',
  fromOverdueWord: '距過期',
  getDayWord(d: number): string {
    return '天'
  },
  noSill: '无门槛',
  getMoney(money: number) {
    return money / 100
  },
  packageMail: '包邮',
  goHomeBtnWord: '去首頁逛逛',
  justUseBtnWord: '去使用',
  receivedMsg: '您已領取過新人禮券啦，去逛逛吧～',
}

const enLang = {
  fullReduct(money: number, currencyCode: string) {
    return `Order ≥ ${currencyCode || ''}${Number(money / 100) || ''}`
  },
  overdueMsg: 'Sorry, your offers expired',
  sorryTopMsg: 'Sorry, these are New User Offers.',
  sorryBottomMsg: 'You have order history with us already.',
  fromOverdueWord: 'Expires in',
  getDayWord(d: number): string {
    return d > 1 ? 'Days' : 'Day'
  },
  noSill: 'With Any Order',
  getMoney(money: number) {
    return money / 100
  },
  packageMail: 'Free Shipping',
  goHomeBtnWord: 'Take a look around',
  justUseBtnWord: 'Use Now',
  receivedMsg: "Welcome offers are in your account now. Check out what's trending.",
}

const jaLang = {
  fullReduct(money: number, currencyCode: string) {
    return `${currencyCode || ''}${money || ''}以上で使える`
  },
  overdueMsg: 'ごめんなさい、特典は期限切れです',
  sorryTopMsg: 'いつものご愛用ありがとうございます',
  sorryBottomMsg: 'この特典は新ユーザー限定です。ご理解ありがとうございます',
  fromOverdueWord: '期限切れまで',
  getDayWord(d: number): string {
    return '日'
  },
  noSill: '任意可用',
  getMoney(money: number) {
    return money
  },
  packageMail: '送料無料',
  goHomeBtnWord: 'ホームページに戻る',
  justUseBtnWord: '今すぐ使う',
  receivedMsg: "新入り特典は受取済みですよ!早速チェックしましょう！",
}

export type LangType = typeof enLang

export const langMap = {
  [LangEum.en]: enLang,
  [LangEum['zh-TW']]: zhTWLang,
  [LangEum['zh-TW2']]: zhTWLang,
  [LangEum['zh-MO']]: zhTWLang,
  [LangEum['zh-SG']]: zhTWLang,
  [LangEum['zh-MY']]: zhTWLang,
  [LangEum.ja]: jaLang,
  [LangEum.zh]: enLang,
}

export default langMap
